// app/javascript/components/ChatBox.js
import { useRef, useEffect, useLayoutEffect, useState, useCallback } from "react";
import { Box, CircularProgress, Snackbar, Alert } from "@mui/material";
import { keyframes } from "@mui/system";
import "../../stylesheets/index.css";
import "../../stylesheets/chat_area.css";
import "../../stylesheets/message.css";
import ChatButton from "./Reusable/ChatButton";
import ChatMessage from "./Chat/ChatMessage";
import get_message_date from "./Chat/MessageDate";
import { useNavigate } from "react-router-dom";
import { isDarkMode, themeColors } from "../utils/constants";
import { ShareModal, ShareButtonChat } from "../utils/share";
import PrintOutText from "./Chat/PrintOutText";
import { SignInApple, SignInGoogle } from "./NewAccountPage";
import { useAppContext } from "../contexts/AppContext";
import { useChatContext } from "../contexts/ChatContext";
import ScrollDown from "./Reusable/ScrollDown";
import { getThreadMessages } from "../api/message";
import { useMemo } from "react";
import NewLogoLightMode from '../images/NewLogoLightMode.png'
import NewLogoDarkMode from '../images/NewLogoDarkMode.png'
import { makeDomIdFactory } from "./Chat/chatMessageIdentity";
import {
  captureViewportAnchor as captureChatViewportAnchor,
  clearAnchorPad as clearChatAnchorPad,
  restoreViewportAnchor as restoreChatViewportAnchor,
  setScrollTopProgrammatically as setChatScrollTopProgrammatically,
  waitForImages as waitForChatImages,
  waitForStableHeight as waitForChatStableHeight,
} from "./Chat/chatScrollPositioning";
import { QUEUED_MESSAGE_STATUS } from "./Chat/queuedChatMessages";

const orbPulsate = keyframes`
  0%   { opacity: 0.18; transform: scale(1); }
  50%  { opacity: 0.42; transform: scale(1.06); }
  100% { opacity: 0.18; transform: scale(1); }
`;

const INITIAL_SCROLL_IMAGE_WAIT_MS = 150//220;
const INITIAL_SCROLL_STABLE_MAX_FRAMES = 24;
const INITIAL_SCROLL_SETTLE_DELAY_MS = 80;
const INITIAL_SCROLL_FOLLOW_UP_MS = 90;//130;
const INITIAL_SCROLL_FAILSAFE_MS = 2200;
const INITIAL_HUMAN_ANCHOR_DELAY_MS = 120;
const ANCHOR_SCROLL_DURATION_MS = 220;
const THREAD_PAGE_LIMIT = 4;
const HISTORY_LOAD_DWELL_MS = 1000;

const ChatBox = (props) => {
  const { appProps } = useAppContext();

  const {
    sidebarOffset,
    chatLayout,
    isDesktop,
    messageThreads,
    onQuestionSubmit,
    onBeginEditMessage,
    onRemoveQueuedMessage,
    onRetryQueuedMessage,
    onRecommendedAction,
    loadingResponse,
    userData,
    setUserData,
    chatRef,
    chatContainerRef,
    chatMessagesContainerRef,
    pendingResolvedThreadUuidRef,
    preventQuestionInput,
    setPreventQuestionInput,
    showLoadingWaitingMessage,
    setShowLoadingWaitingMessage,
    useFullWidth,
    // showNewUserMessage,
    isSecondaryExperience,
    isNewUUID,
    loadingUserData,
    setIsSecondaryExperience,
    showSignInButtons,
    setQuestionOnDemand,
    anchorOffsetTop,
    editingMessage,
    skipHideThreadUuid,
  } = props;

  const {
    experienceMessageThreads,
    showScrollDown,
    setShowScrollDown,
    secondaryExperienceType,
    questionOnDemand,
    freeUnlimitedOnly,
    hasShownFreeUnlimitedMessage,
    activeThread,
    loadingMessages,
    loadingPhaseMessage,
    liveTextOutputting,
    setThreadViewLoading,
    scrollToMessageId,
    setScrollToMessageId,
  } = useChatContext();

  const {
    responseFlow,
    setMessageThreads,
    showChatShare,
    setShowChatShare,
  } = appProps;

  const navigate = useNavigate();

  const [transitionFlowButtonsAmount, setTransitionFlowButtonsAmount] =
    useState(0);
  const [transitionFlowRegenAmount, setTransitionFlowRegenAmount] = useState(0);
  // const [testVal, setTestVal] = useState(null);
  const chatMessageRef = useRef();
  const [loadingShowHistory, setLoadingShowHistory] = useState(true); //useState(true)
  const [modalVisible, setModalVisible] = useState(false);
  const [showInitialMesageFlow, setShowInitialMesageFlow] = useState(false);
  const [displayChatBox, setDisplayChatBox] = useState(true); //useState(false)
  const [showButon1, setShowButon1] = useState(0);
  const [showButon2, setShowButon2] = useState(0);
  const [showMore, setShowMore] = useState(0);
  const [showOrb, setShowOrb] = useState(0);
  const [hasRefreshedButtons, setHasRefreshedButtons] = useState(false);
  // const [canSeeWhy, setCanSeeWhy] = useState(0);
  // const [isSelected, setIsSelected] = useState("");
  const [errors, setErrors] = useState([]);
  const [messageThreadLoaded, setMessageThreadLoaded] = useState(false);
  const [needsHistory, setNeedsHistory] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loadingOlder, setLoadingOlder] = useState(false);
  const [historyLoadIntentActive, setHistoryLoadIntentActive] = useState(false);
  const [historyInlineNotice, setHistoryInlineNotice] = useState("");
  const [userDetachedFromResponseAnchor, setUserDetachedFromResponseAnchor] = useState(false);
  const loadingOlderRef = useRef(false);
  const pendingHistoryScrollRef = useRef(null);
  // Always-current view of messageThreads so loadOlderMessages computes the
  // pagination cursor from live data even when invoked from a stale closure.
  const messageThreadsRef = useRef(messageThreads);
  messageThreadsRef.current = messageThreads;
  // Live mirror of hasMore so the load-older path stops fetching once history
  // is exhausted, even when invoked from a stale closure.
  const hasMoreRef = useRef(true);
  hasMoreRef.current = hasMore;
  const historyWasPagedRef = useRef(false);
  const historyLoadIntentTimerRef = useRef(null);
  const historyNoticeTimerRef = useRef(null);


  const stickyElRef = useRef(null);
  const padElRef = useRef(null);
  const topSentinelRef = useRef(null);
  const suppressScrollRef = useRef(0);
  const lastAtBottomRef = useRef(null);
  const autoStickBottomRef = useRef(true);
  const startReachedCalledRef = useRef(false);
  const responseJustEndedRef = useRef(false);
  const anchorTargetRef = useRef(null);
  const messageRefs = useRef(new Map());
  const lastAnchoredQuestionKeyRef = useRef(null);
  const activeAnchorMessageKeyRef = useRef(null);
  const followAnchorDuringLoadRef = useRef(false);
  const preserveAnchorPadAfterResponseRef = useRef(false);
  const userScrollAnchorRef = useRef(null);
  const userScrollIntentRef = useRef(false);
  const userScrollIntentTimerRef = useRef(null);
  const activeStickyMessageIdRef = useRef(null);
  const anchorScrollAnimationRef = useRef(null);
  const didInitialScroll = useRef(false)
  const prevThreadUuidRef = useRef(null);
  const skipNextBottomPinRef = useRef(false);
  const loadingResponseRef = useRef(Boolean(loadingResponse));
  const chatLoadPerfRef = useRef({
    threadUuid: null,
    startedAtMs: 0,
    revealed: false,
  });

  const bottomSentinelRef = useRef(null);
  const initialScrollDoneRef = useRef(false);

  // const clientKeyMap = useRef(new WeakMap()).current;

  const [hideChatThread, setHideChatThread] = useState(true)

  useEffect(() => {
    loadingResponseRef.current = Boolean(loadingResponse);
    if (loadingResponse) {
      setUserDetachedFromResponseAnchor(false);
      userScrollIntentRef.current = false;
    }
  }, [loadingResponse]);

	  useEffect(() => (
	    () => {
	      if (userScrollIntentTimerRef.current) {
	        clearTimeout(userScrollIntentTimerRef.current);
	      }
	      if (anchorScrollAnimationRef.current?.rafId) {
	        cancelAnimationFrame(anchorScrollAnimationRef.current.rafId);
	      }
	    }
	  ), []);

  // const domIdFor = useCallback((m) => {
  //   //Set stable id for pinning user message to the top
  //   if (m.id) return m.id;
  //   if (m.uuid) return m.uuid;
  //   const existing = clientKeyMap.get(m);
  //   if (existing) return existing;
  //   const k = `c-${Math.random().toString(36).slice(2)}`;
  //   clientKeyMap.set(m, k);
  //   return k;
  // }, [clientKeyMap]);

  const domIdFor = useMemo(
    () => makeDomIdFactory(activeThread?.threadUuid || "global"),
    [activeThread?.threadUuid]
  );

  const isDirectThread = Boolean(activeThread?.pairedThreadId);
  const activeThreadUuid = activeThread?.threadUuid ?? null;
  const messageCount = Array.isArray(messageThreads) ? messageThreads.length : 0;
  const visibleMessageThreads = useMemo(
    () =>
      Array.isArray(messageThreads)
        ? messageThreads.filter(
            (message) =>
              message?.queueStatus !== QUEUED_MESSAGE_STATUS.QUEUED,
          )
        : [],
    [messageThreads],
  );
  // Pin the loading orb to the last human message so empty bot placeholders
  // pushed by Phase 3 optimistic chart broadcasts don't cause an unmount/remount
  // flicker when the orb hops to the new last message.
  const orbAnchorIdx = useMemo(() => {
    if (visibleMessageThreads.length === 0) return -1;
    for (let i = visibleMessageThreads.length - 1; i >= 0; i--) {
      const message = visibleMessageThreads[i];
      if (
        message?.sender === "human" &&
        (
          !message.queueStatus ||
          message.queueStatus === QUEUED_MESSAGE_STATUS.SENDING
        )
      ) {
        return i;
      }
    }
    return visibleMessageThreads.length - 1;
  }, [visibleMessageThreads]);
  const shouldRenderQuestion1Button =
    Boolean(isSecondaryExperience) ||
    Boolean(responseFlow?.question1?.[0] && responseFlow?.question1?.[1]);
  const shouldRenderQuestion2Button =
    Boolean(isSecondaryExperience) ||
    Boolean(responseFlow?.question2?.[0] && responseFlow?.question2?.[1]);
  const chatLoadPerfDebug = useMemo(() => {
    if (typeof window === "undefined") return false;
    try {
      return window.localStorage?.getItem("chat_load_perf_debug") === "1";
    } catch {
      return false;
    }
  }, []);
  const pushChatLoadMetric = useCallback(
    (event, extra = {}) => {
      if (typeof window === "undefined" || typeof performance === "undefined") return;
      const perfEnabled =
        chatLoadPerfDebug || window.__chatLoadMetricsEnabled === true;
      if (!perfEnabled) return;
      const perf = chatLoadPerfRef.current || {};
      const now = performance.now();
      const elapsedMs = perf?.startedAtMs
        ? Math.round(now - perf.startedAtMs)
        : null;
      const metric = {
        timestamp: new Date().toISOString(),
        event,
        threadUuid: perf?.threadUuid || activeThread?.threadUuid || null,
        elapsedMs,
        ...extra,
      };
      if (!Array.isArray(window.__chatLoadMetrics)) {
        window.__chatLoadMetrics = [];
      }
      window.__chatLoadMetrics.push(metric);
      if (window.__chatLoadMetrics.length > 300) {
        window.__chatLoadMetrics.shift();
      }
      if (chatLoadPerfDebug) {
        console.debug("[ChatLoadPerf]", metric);
      }
    },
    [activeThread?.threadUuid, chatLoadPerfDebug],
  );

  const setScrollTopProgrammatically = useCallback((element, value, _reason = "programmatic", options = {}) => {
    const { smooth = false, duration = ANCHOR_SCROLL_DURATION_MS } = options || {};
    setChatScrollTopProgrammatically({
      element,
      value,
      suppressScrollRef,
      anchorScrollAnimationRef,
      smooth,
      duration,
    });
  }, []);

  const clearAnchorPad = useCallback(({ preserveViewport = false } = {}) => {
    clearChatAnchorPad({
      pad: padElRef.current,
      scroller: chatContainerRef.current,
      preserveViewport,
    });
  }, [chatContainerRef]);

  const captureViewportAnchor = useCallback((scroller, { excludeIds = [] } = {}) => {
    return captureChatViewportAnchor({
      scroller,
      messageRefs: messageRefs.current,
      excludeIds,
    });
  }, []);

  const restoreViewportAnchor = useCallback((anchor) => {
    restoreChatViewportAnchor({
      anchor,
      scroller: chatContainerRef.current,
      messageRefs: messageRefs.current,
      suppressScrollRef,
    });
  }, [chatContainerRef]);

  const beginChatLoadMetric = useCallback(
    (threadUuid, reason) => {
      if (!threadUuid || threadUuid.startsWith("temp-")) return;
      if (typeof performance === "undefined") return;
      chatLoadPerfRef.current = {
        threadUuid,
        startedAtMs: performance.now(),
        revealed: false,
      };
      pushChatLoadMetric("start", { reason });
    },
    [pushChatLoadMetric],
  );

  const revealChatLoadMetric = useCallback(
    (source, extra = {}) => {
      const perf = chatLoadPerfRef.current;
      if (!perf?.startedAtMs || perf?.revealed) return;
      chatLoadPerfRef.current = {
        ...(perf || {}),
        revealed: true,
      };
      pushChatLoadMetric("revealed", { source, ...extra });
    },
    [pushChatLoadMetric],
  );


  const setMsgRef = useCallback(
    (id) => (el) => {
      if (el) {
        messageRefs.current.set(id, el);
      } else {
        messageRefs.current.delete(id);
      }
    },
    []
  );


  let newUserQuestion1;
  let newUserQuestion2;
  if (secondaryExperienceType == "new-user") {
    newUserQuestion1 = "Best Tech Stock?";
    newUserQuestion2 = "Crypto To Buy?";
  } else if (secondaryExperienceType == "ask-share") {
    newUserQuestion1 = "Share Incite App";
    newUserQuestion2 = "Continue using Incite";
  }

  const markUserScrollIntent = useCallback((event) => {
    if (!loadingResponseRef.current) return;
    if (event?.type === "mousedown" && event.target !== event.currentTarget) {
      return;
    }

    userScrollIntentRef.current = true;
    if (userScrollIntentTimerRef.current) {
      clearTimeout(userScrollIntentTimerRef.current);
    }
    userScrollIntentTimerRef.current = setTimeout(() => {
      userScrollIntentRef.current = false;
      userScrollIntentTimerRef.current = null;
    }, 300);
  }, []);


  const handleScrollDown = useCallback(
    (e) => {
      const el = e.currentTarget;
      if (suppressScrollRef.current > 0 || anchorTargetRef.current != null) {
        return;
      }
      const userInitiatedScroll =
        loadingResponseRef.current && userScrollIntentRef.current;
      if (userInitiatedScroll && preserveAnchorPadAfterResponseRef.current) {
        preserveAnchorPadAfterResponseRef.current = false;
        followAnchorDuringLoadRef.current = false;
        setUserDetachedFromResponseAnchor(true);
        userScrollAnchorRef.current = captureViewportAnchor(el, {
          excludeIds: [activeStickyMessageIdRef.current],
        });
      } else if (userInitiatedScroll) {
        followAnchorDuringLoadRef.current = false;
        setUserDetachedFromResponseAnchor(true);
        userScrollAnchorRef.current = captureViewportAnchor(el, {
          excludeIds: [activeStickyMessageIdRef.current],
        });
      }
      const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 200; // so it has to be 100px up to be at the bottom
      if (!atBottom) {
        // user intentionally moved off-bottom; stop auto locking until they return
        autoStickBottomRef.current = false;
      } else {
        autoStickBottomRef.current = true;
      }
      if (lastAtBottomRef.current !== atBottom) {
        lastAtBottomRef.current = atBottom;
        setShowScrollDown(!atBottom);
      }
    },
    [captureViewportAnchor, setShowScrollDown]
  );


  const handleRegenerateSubmit = async (question = null) => {
    if (showSignInButtons) {
      navigate("/register");
    }

    setTransitionFlowButtonsAmount(0.0);
    setTransitionFlowRegenAmount(0.0);

    // Allow new buttons instead of default ones (only relevent for new users)
    setHasRefreshedButtons(true);

    setTimeout(() => {
      setTransitionFlowButtonsAmount(0.99);
      setTransitionFlowRegenAmount(0.99);
    }, 150);
    // dispatch to server with these new questions
    // server will update table to "attach" new questions
    // to that last chat message. It will update the row

    if (chatMessageRef.current) {
      // chatMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };


  const isLoggedIn = !!userData.user_id;
  const waitForImages = useCallback(async (maxWaitMs = INITIAL_SCROLL_IMAGE_WAIT_MS) => {
    await waitForChatImages(chatMessagesContainerRef.current, maxWaitMs);
  }, [chatMessagesContainerRef]);

  const waitForStableHeight = useCallback(async (el, { stableFrames = 2, maxFrames = INITIAL_SCROLL_STABLE_MAX_FRAMES } = {}) => {
    await waitForChatStableHeight(el, { stableFrames, maxFrames });
  }, []);

  // Reset the "initial scroll" gate when the active thread changes
  useLayoutEffect(() => {
    const threadUuid = activeThread?.threadUuid;
    const prevThreadUuid = prevThreadUuidRef.current;
    const isCachedThreadSwitch =
      Boolean(threadUuid) && skipHideThreadUuid === threadUuid;
    // An explicit handoff from resolveTempId: the active thread's temp/new uuid
    // just resolved to its real value in-place. Treat as a resolve regardless of
    // loading-flag timing so the scroll position is preserved.
    const isExplicitResolve =
      Boolean(threadUuid) &&
      pendingResolvedThreadUuidRef?.current === threadUuid;
    const isTempToRealResolve =
      isExplicitResolve ||
      (Boolean(prevThreadUuid?.startsWith("temp-")) &&
        Boolean(threadUuid) &&
        !threadUuid.startsWith("temp-") &&
        Boolean(loadingResponseRef.current));

    initialScrollDoneRef.current = false;
    if (isTempToRealResolve) {
      didInitialScroll.current = true;
      initialScrollDoneRef.current = true;
      skipNextBottomPinRef.current = true;
      pushChatLoadMetric("skip-hide", {
        reason: "temp-to-real-resolve",
        fromThreadUuid: prevThreadUuid,
        toThreadUuid: threadUuid,
      });
      setHideChatThread(false);
      revealChatLoadMetric("skip-hide-temp-to-real-resolve");
      return;
    }
    if (isCachedThreadSwitch) {
      // The scroll container is reused across thread switches, so cached
      // threads still need the normal bottom-lock pass before reveal.
      beginChatLoadMetric(threadUuid, "thread-switch-cached");
      pushChatLoadMetric("cached-thread-bottom-lock");
      setHideChatThread(true);
      return;
    }
    if (!threadUuid || threadUuid.startsWith("temp-") || isSecondaryExperience) {
      pushChatLoadMetric("skip-hide", {
        reason: !threadUuid
          ? "no-thread"
          : threadUuid.startsWith("temp-")
            ? "temp-thread"
            : "secondary-experience",
      });
      setHideChatThread(false);
      revealChatLoadMetric("skip-hide");
      return;
    }
    // Always hide real-thread content on thread switch; reveal only after bottom-lock.
    beginChatLoadMetric(threadUuid, "thread-switch");
    setHideChatThread(true);
  }, [
    activeThread?.threadUuid,
    skipHideThreadUuid,
    isSecondaryExperience,
    beginChatLoadMetric,
    pushChatLoadMetric,
    revealChatLoadMetric,
  ]);

  useEffect(() => {
    if (isSecondaryExperience) {
      setHideChatThread(false);
      revealChatLoadMetric("secondary-experience");
    }
  }, [isSecondaryExperience, revealChatLoadMetric])

  useEffect(() => {
    setThreadViewLoading(Boolean(!isSecondaryExperience && hideChatThread));
  }, [hideChatThread, isSecondaryExperience, setThreadViewLoading]);


  // Failsafe: if initial scroll logic stalls, force bottom then reveal.
  useEffect(() => {
    if (!hideChatThread) return;
    if (loadingMessages) return;
    const timeoutId = setTimeout(() => {
      if (!hideChatThread) return;
      if (loadingMessages) return;
      const el = chatContainerRef.current;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
      didInitialScroll.current = true;
      initialScrollDoneRef.current = true;
      lastAtBottomRef.current = true;
      setShowScrollDown(false);
      setHideChatThread(false);
      revealChatLoadMetric("failsafe-timeout", {
        timeoutMs: INITIAL_SCROLL_FAILSAFE_MS,
      });
    }, INITIAL_SCROLL_FAILSAFE_MS);

    return () => clearTimeout(timeoutId);
  }, [
    activeThread?.threadUuid,
    hideChatThread,
    loadingMessages,
    setShowScrollDown,
    revealChatLoadMetric,
  ]);

  useEffect(() => {
    // On an in-place temp/new -> real thread resolve, the conversation
    // continues; resetting the anchor/scroll/infinite-scroll state here would
    // re-anchor the question to the top after the answer already arrived (the
    // reported "jumps to the top" bug). Skip it for the resolve.
    if (
      pendingResolvedThreadUuidRef?.current &&
      pendingResolvedThreadUuidRef.current === activeThread?.threadUuid
    ) {
      return;
    }
    if (historyLoadIntentTimerRef.current) {
      clearTimeout(historyLoadIntentTimerRef.current);
      historyLoadIntentTimerRef.current = null;
    }
    if (historyNoticeTimerRef.current) {
      clearTimeout(historyNoticeTimerRef.current);
      historyNoticeTimerRef.current = null;
    }
    setLoadingOlder(false);
    setHistoryLoadIntentActive(false);
    setHistoryInlineNotice("");
    loadingOlderRef.current = false;
    historyWasPagedRef.current = false;
    autoStickBottomRef.current = true;
    lastAtBottomRef.current = true;
    lastAnchoredQuestionKeyRef.current = null;
    activeAnchorMessageKeyRef.current = null;
    followAnchorDuringLoadRef.current = false;
    preserveAnchorPadAfterResponseRef.current = false;
    userScrollAnchorRef.current = null;
    userScrollIntentRef.current = false;
    activeStickyMessageIdRef.current = null;
    setUserDetachedFromResponseAnchor(false);
    clearAnchorPad();
    setHasMore(true);
    startReachedCalledRef.current = false;
  }, [activeThread?.threadUuid, clearAnchorPad]);

  useEffect(() => {
    const curr = activeThread?.threadUuid ?? null;
    const prev = prevThreadUuidRef.current;
    if (prev === curr) return; // only run if thread uuid has changed..
    const isExplicitResolve =
      Boolean(curr) && pendingResolvedThreadUuidRef?.current === curr;
    const isTempToRealResolve =
      isExplicitResolve ||
      (Boolean(prev?.startsWith("temp-")) &&
        Boolean(curr) &&
        !curr.startsWith("temp-") &&
        Boolean(loadingResponseRef.current));
    // Consume the one-shot resolve handoff now that both thread-change effects
    // have seen it (this passive effect runs after the layout effect above).
    if (isExplicitResolve) {
      pendingResolvedThreadUuidRef.current = null;
    }
    didInitialScroll.current = isTempToRealResolve
      ? true
      : Boolean(curr?.startsWith("temp-"));
    prevThreadUuidRef.current = curr;
  }, [activeThread?.threadUuid]);


  // helper: set pad to exactly the underfill so content hugs the bottom
  const adjustBottomPad = useCallback(() => {
    const scroller = chatContainerRef.current;
    const pad = padElRef.current;
    const contentRoot = chatMessagesContainerRef.current;
    if (!scroller || !pad || !contentRoot) return;
    const currentGap = scroller.clientHeight - (scroller.scrollHeight - scroller.scrollTop);
    let new_height = pad.offsetHeight + currentGap
    if (new_height < 0) new_height = 0
    pad.style.height = `${new_height}px`;
  }, [
    chatContainerRef,
    chatMessagesContainerRef,
    padElRef,
    lastAtBottomRef,
  ]);

  
  useLayoutEffect(() => {
    if (loadingResponse) return;
    const manualAnchor = userScrollAnchorRef.current;
    const shouldPreserveViewport =
      Boolean(manualAnchor) || (padElRef.current?.offsetHeight || 0) > 0;
    preserveAnchorPadAfterResponseRef.current = false;
    userScrollAnchorRef.current = null;
    clearAnchorPad({ preserveViewport: shouldPreserveViewport });
    restoreViewportAnchor(manualAnchor);

    if (!shouldPreserveViewport) return undefined;

    let rafId = requestAnimationFrame(() => {
      clearAnchorPad({ preserveViewport: true });
      restoreViewportAnchor(manualAnchor);
    });
    const settleTimerId = setTimeout(() => {
      rafId = requestAnimationFrame(() => {
        clearAnchorPad({ preserveViewport: true });
        restoreViewportAnchor(manualAnchor);
      });
    }, 80);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(settleTimerId);
    };
  }, [
    activeThread?.threadUuid,
    clearAnchorPad,
    loadingResponse,
    restoreViewportAnchor,
  ]);

  useEffect(() => {
    if (loadingResponse) return;
    if (!hideChatThread) return;
    if (padElRef.current) {
      setTimeout(() => {
        requestAnimationFrame(adjustBottomPad);
      }, 24) // slight delay here is important.
    }
  }, [adjustBottomPad, hideChatThread, loadingResponse]);


  // Track when response just finished to prevent immediate bottom-pin scrolling
  useEffect(() => {
    const wasLoading = loadingResponseRef.current;
    loadingResponseRef.current = loadingResponse;

    if (wasLoading && !loadingResponse) {
      responseJustEndedRef.current = true;
      const timer = setTimeout(() => {
        responseJustEndedRef.current = false;
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [loadingResponse]);

  // Keep the viewport pinned to the same content after older messages are
  // prepended. CSS scroll-anchor is unreliable when the user is at the very
  // top, so restore the scroll position explicitly by the height delta.
  useLayoutEffect(() => {
    const pending = pendingHistoryScrollRef.current;
    if (!pending) return;
    pendingHistoryScrollRef.current = null;
    const el = chatContainerRef.current;
    if (!el) {
      return;
    }
    const addedHeight = el.scrollHeight - pending.prevScrollHeight;
    if (addedHeight <= 0) {
      return;
    }
    const targetScrollTop = pending.prevScrollTop + addedHeight;
    el.scrollTop = targetScrollTop;
  }, [messageThreads]);

  // Detect when user scrolls to top to load older messages
  useEffect(() => {
    const sentinel = topSentinelRef.current;
    const root = chatContainerRef.current;
    if (!sentinel || !root) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          handleStartReached();
        }
      },
      { root, rootMargin: "0px", threshold: 0.01 }
    );

    observer.observe(sentinel);
    return () => {
      observer.disconnect();
    };
  }, [handleStartReached, chatContainerRef.current, hideChatThread]);

  // Diagnostic: track whether prepended older messages reach React state.
  useEffect(() => {
    const count = Array.isArray(messageThreads) ? messageThreads.length : 0;
    const first = count ? messageThreads[0] : null;
    const last = count ? messageThreads[count - 1] : null;
  }, [messageThreads]);


  // Do the first-time scroll precisely when ready, then unhide
  useLayoutEffect(() => {
    if (didInitialScroll.current == true) return;
    const scroller = chatContainerRef.current;
    if (!scroller) return;
    if (!chatContainerRef.current) return;
    if (loadingMessages) return;
    if (scrollToMessageId) return;
    if (!showInitialMesageFlow || !messageThreadLoaded) return;
    if (initialScrollDoneRef.current) return;

    let cancelled = false;
    const followUpTimers = [];
    const run = async () => {
      suppressScrollRef.current++;
      if (!chatContainerRef.current) return;
      try {
        pushChatLoadMetric("initial-scroll-run", {
          messageCount: Array.isArray(messageThreads) ? messageThreads.length : 0,
        });
        await waitForImages(INITIAL_SCROLL_IMAGE_WAIT_MS);
        pushChatLoadMetric("initial-scroll-after-images");
        await waitForStableHeight(scroller);
        pushChatLoadMetric("initial-scroll-after-stable-height-1");
        // Short settle pass for late-rendering blocks without adding long fixed latency.
        await new Promise((resolve) => setTimeout(resolve, INITIAL_SCROLL_SETTLE_DELAY_MS));
        await waitForStableHeight(scroller);
        pushChatLoadMetric("initial-scroll-after-stable-height-2");
        if (cancelled) return;
        
        const forceBottom = () => {
          const el = chatContainerRef.current;
          if (!el || cancelled) return;
          el.scrollTop = el.scrollHeight;
        };

        forceBottom();
        // One short follow-up pass, then reveal.
        followUpTimers.push(
          setTimeout(() => {
            forceBottom();
            if (cancelled) return;
            setHideChatThread(false); // reveal only after the final bottom-lock pass
            revealChatLoadMetric("initial-scroll-followup", {
              followUpDelayMs: INITIAL_SCROLL_FOLLOW_UP_MS,
            });
          }, INITIAL_SCROLL_FOLLOW_UP_MS),
        );
        didInitialScroll.current = true;

        lastAtBottomRef.current = true;
        setShowScrollDown(false);
        initialScrollDoneRef.current = true;

      } finally {
        suppressScrollRef.current--;
      }
    };

    run();
    return () => {
      cancelled = true;
      followUpTimers.forEach((id) => clearTimeout(id));
    };
  }, [
    activeThread?.threadUuid,
    initialScrollDoneRef.current,
    chatContainerRef.current,
    showInitialMesageFlow,
    messageThreadLoaded,
    loadingMessages,
    loadingResponse,
    waitForImages,
    waitForStableHeight,
    messageThreads?.length,
    pushChatLoadMetric,
    revealChatLoadMetric,
  ]);

  // Keep the active thread pinned to the bottom while layout is still settling
  // (charts/images can resize after initial render).
  useEffect(() => {
    const threadUuid = activeThread?.threadUuid;
    if (!threadUuid || threadUuid.startsWith("temp-")) return;
    if (scrollToMessageId) return;
    if (!hideChatThread) {
      return;
    }
    if (loadingResponse) {
      return;
    }
    // Skip if response just finished (avoid scroll to bottom right after response)
    if (loadingResponseRef.current) {
      return;
    }
    if (skipNextBottomPinRef.current) {
      skipNextBottomPinRef.current = false;
      return;
    }

    const scroller = chatContainerRef.current;
    const contentRoot = chatMessagesContainerRef.current;
    if (!scroller || !contentRoot) return;

    autoStickBottomRef.current = true;
    let rafId = null;

    const syncBottom = () => {
      const el = chatContainerRef.current;
      if (!el) return;

      // Don't scroll if a response is loading - prevent race condition with ResizeObserver
      if (loadingResponseRef.current) {
        return;
      }

      const remaining = el.scrollHeight - el.scrollTop - el.clientHeight;
      const nearBottom = remaining <= 220;
      if (!autoStickBottomRef.current && !nearBottom && !lastAtBottomRef.current) {
        return;
      }
      suppressScrollRef.current++;
      el.scrollTop = el.scrollHeight;
      suppressScrollRef.current--;
      lastAtBottomRef.current = true;
      setShowScrollDown(false);
    };

    const scheduleSync = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(syncBottom);
    };

    scheduleSync();
    const settleTimers = [80, 220, 520].map((ms) =>
      setTimeout(() => {
        scheduleSync();
      }, ms),
    );
    const releaseTimerId = setTimeout(() => {
      autoStickBottomRef.current = false;
    }, 1400);

    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(() => {
        scheduleSync();
      });
      resizeObserver.observe(contentRoot);
      resizeObserver.observe(scroller);
    }

    return () => {
      settleTimers.forEach((id) => clearTimeout(id));
      clearTimeout(releaseTimerId);
      if (rafId) cancelAnimationFrame(rafId);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, [
    activeThread?.threadUuid,
    scrollToMessageId,
    hideChatThread,
    loadingResponse,
    chatContainerRef,
    chatMessagesContainerRef,
    setShowScrollDown,
  ]);

  useEffect(() => {
    if (userData && userData.uuid) {
      if (Object.keys(userData).length) {
        //} && (isLoggedIn || !userData.uuidHasAccount)) {
        setLoadingShowHistory(false);
        setNeedsHistory(true); // this will cause the trigger to get the history.
        // getMessageHistory(
        //   appProps.setHasShownHistory,
        //   true,
        //   setLoadingUserMessages
        // );
      } else {
        setNeedsHistory(false);
      }
    }
  }, [userData && userData.uuid]); // So this only fires once, and only when the user data is there (for pre account or user account)

  // useEffect(() => {
  //   if (!loadingResponse) {
  //     if (
  //       messageThreads.length > 1 &&
  //       messageThreads[messageThreads.length - 2].message != "Explain why?"
  //     ) {
  //       setCanSeeWhy(0.99);
  //     } else {
  //       setCanSeeWhy(0);
  //     }
  //   }
  // }, [messageThreads, loadingResponse]);

  // useEffect(() => {
  //   if (isSelected != "") {
  //     setIsSelected("");
  //   }
  // }, [loadingResponse]);

  const executeScroll = () => {
    const el = chatContainerRef.current;
    if (!el || loadingResponse) return;
    el.scrollTop = el.scrollHeight;
  };

  let countSinceShowMessageTime = 0;
  const logHistoryDebug = useCallback(
    (event, details = {}) => {
      const payload = {
        event,
        threadUuid: activeThreadUuid,
        hasMore,
        messageCount,
        loadingOlder: loadingOlderRef.current,
        historyLoadIntentActive: Boolean(historyLoadIntentTimerRef.current) || historyLoadIntentActive,
        historyInlineNotice,
        ...details,
      };
      if (typeof window !== "undefined") {
        if (!Array.isArray(window.__chatHistoryLogs)) {
          window.__chatHistoryLogs = [];
        }
        window.__chatHistoryLogs.push(payload);
        if (window.__chatHistoryLogs.length > 300) {
          window.__chatHistoryLogs.shift();
        }
      }

    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeThreadUuid, hasMore, messageCount],
  );
  const showHistoryInlineNotice = useCallback(
    (message, details = {}) => {
      setHistoryInlineNotice(message);
      logHistoryDebug("history-notice-show", {
        message,
        ...details,
      });
      if (historyNoticeTimerRef.current) {
        clearTimeout(historyNoticeTimerRef.current);
      }
      historyNoticeTimerRef.current = setTimeout(() => {
        historyNoticeTimerRef.current = null;
        setHistoryInlineNotice("");
        logHistoryDebug("history-notice-clear", {
          reason: "notice-timeout",
          message,
          ...details,
        });
      }, 4000);
    },
    [logHistoryDebug],
  );

  useEffect(() => {
    if (responseFlow.question1[0]) {
      setTransitionFlowButtonsAmount(0.99);
    } else {
      setTransitionFlowButtonsAmount(0);
    }
  }, [responseFlow.question1[0]]);

  const loadOlderMessages = useCallback(
    async (thread) => {
      const threadUuid = thread?.threadUuid;
      if (!threadUuid || threadUuid.startsWith("temp-")) {
        logHistoryDebug("fetch-skip", { reason: "invalid-thread", requestedThreadUuid: threadUuid });
        return;
      }
      if (!hasMoreRef.current || loadingOlderRef.current) {
        logHistoryDebug("fetch-skip", {
          reason: !hasMoreRef.current ? "no-more-history" : "already-loading",
          requestedThreadUuid: threadUuid,
        });
        return;
      }
      if (activeThread?.threadUuid !== threadUuid) {
        logHistoryDebug("fetch-skip", {
          reason: "thread-mismatch",
          requestedThreadUuid: threadUuid,
          activeThreadUuid: activeThread?.threadUuid,
        });
        return;
      }

      const el = chatContainerRef.current;
      if (!el) {
        logHistoryDebug("fetch-skip", { reason: "missing-scroller", requestedThreadUuid: threadUuid });
        return;
      }

      const currentThreads = messageThreadsRef.current;
      const before = currentThreads.length ? currentThreads[0].createdAt : null;
      const beforeId = currentThreads.length ? currentThreads[0].id : null;
      loadingOlderRef.current = true;
      setLoadingOlder(true);
      setHistoryLoadIntentActive(false);
      setHistoryInlineNotice("");
      logHistoryDebug("fetch-start", {
        requestedThreadUuid: threadUuid,
        before,
      });

      try {
        const older = await getThreadMessages({
          threadUuid,
          limit: THREAD_PAGE_LIMIT,
          beforeTs: before,
          beforeId,
        });
        logHistoryDebug("fetch-result", {
          requestedThreadUuid: threadUuid,
          before,
          resultCount: Array.isArray(older) ? older.length : null,
          firstReturnedCreatedAt: Array.isArray(older) && older[0] ? older[0].createdAt : null,
          lastReturnedCreatedAt:
            Array.isArray(older) && older.length > 0 ? older[older.length - 1].createdAt : null,
        });
        if (activeThread?.threadUuid !== threadUuid) {
          logHistoryDebug("fetch-abort", {
            reason: "thread-changed-after-fetch",
            requestedThreadUuid: threadUuid,
            activeThreadUuid: activeThread?.threadUuid,
          });
          return;
        }
        if (!Array.isArray(older) || older.length === 0) {
          setHasMore(false);
          // Only tell the user they've reached the beginning when they actually
          // paged through history (i.e., a previous fetch returned a full page).
          // If the very first history fetch returns nothing it means all messages
          // were already loaded in the initial render — no notice needed.
          if (historyWasPagedRef.current) {
            showHistoryInlineNotice("No earlier messages in this thread.", {
              reason: "zero-results",
              requestedThreadUuid: threadUuid,
              before,
            });
          }
          return;
        }

        const reachedHistoryEnd = older.length < THREAD_PAGE_LIMIT;
        // Fetching a full page means there may be more history beyond this.
        if (!reachedHistoryEnd) {
          historyWasPagedRef.current = true;
        }
        // Snapshot scroll metrics so the layout effect can keep the viewport
        // pinned to the same content after older messages are prepended.
        pendingHistoryScrollRef.current = {
          prevScrollHeight: el.scrollHeight,
          prevScrollTop: el.scrollTop,
        };
        setMessageThreads((prev) => {
          const merged = [...older, ...prev];
          const seen = new Set();
          const deduped = merged.filter((m) => {
            const key = m.id || m.uuid || m.createdAt;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          return deduped;
        });

        if (reachedHistoryEnd) {
          setHasMore(false);
          logHistoryDebug("history-end-reached", {
            reason: "partial-page",
            requestedThreadUuid: threadUuid,
            resultCount: older.length,
          });
          // Show notice synchronously so it batches with setMessageThreads and
          // setLoadingOlder — ensuring the notice never renders before the
          // prepended messages are visible.
          showHistoryInlineNotice("No earlier messages in this thread.", {
            reason: "partial-page",
            requestedThreadUuid: threadUuid,
            before,
            resultCount: older.length,
          });
        }
      } finally {
        loadingOlderRef.current = false;
        setLoadingOlder(false);
        logHistoryDebug("fetch-complete", {
          requestedThreadUuid: threadUuid,
        });
      }
    },
    [
      activeThread?.threadUuid,
      chatContainerRef,
      hasMore,
      logHistoryDebug,
      messageThreads,
      setMessageThreads,
      showHistoryInlineNotice,
    ],
  );

  const scrollLastHumanToTop = useCallback(() => {
    if (loadingResponseRef.current && !followAnchorDuringLoadRef.current) return;
    const scroller = chatContainerRef.current;
    preserveAnchorPadAfterResponseRef.current = false;
    clearAnchorPad();
    if (!scroller || !messageThreads?.length) return;
    const anchoredHuman = [...messageThreads]
      .reverse()
      .find((message) => message?.sender === "human" && (!liveTextOutputting || message?.shouldAnchor));
    if (!anchoredHuman) {
      return;
    }

    const id = domIdFor(anchoredHuman);
    activeStickyMessageIdRef.current = id;
    const el = messageRefs.current.get(id);
    if (!el) {
      return;
    }

    const sr = scroller.getBoundingClientRect();
    const er = el.getBoundingClientRect();
    const offset = anchorOffsetTop || 0;

    const desiredTop = scroller.scrollTop + (er.top - sr.top) - offset;
    const maxTop = scroller.scrollHeight - scroller.clientHeight;
    const needed = Math.max(0, desiredTop - maxTop);
    if (needed > 0 && padElRef.current) {
      padElRef.current.style.height = `${Math.ceil(needed)}px`;
      preserveAnchorPadAfterResponseRef.current = true;
    }
    setScrollTopProgrammatically(scroller, desiredTop, "last-human-anchor", {
      smooth: true,
      duration: ANCHOR_SCROLL_DURATION_MS,
    });

    lastAtBottomRef.current = false;

    const hasOverflow = (scroller.scrollHeight - scroller.clientHeight) > 1;
    const remaining = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
    const atBottom = !hasOverflow ? true : remaining <= 200;
    lastAtBottomRef.current = atBottom;
    setShowScrollDown(hasOverflow && !atBottom);
  }, [
    anchorOffsetTop,
    chatContainerRef,
    clearAnchorPad,
    domIdFor,
    liveTextOutputting,
    messageThreads,
    setScrollTopProgrammatically,
    setShowScrollDown,
  ]);

  useLayoutEffect(() => {
    if (!loadingResponse) {
      lastAnchoredQuestionKeyRef.current = null;
      activeAnchorMessageKeyRef.current = null;
      followAnchorDuringLoadRef.current = false;
      activeStickyMessageIdRef.current = null;
      return;
    }
    if (userDetachedFromResponseAnchor) {
      lastAnchoredQuestionKeyRef.current = null;
      activeAnchorMessageKeyRef.current = null;
      followAnchorDuringLoadRef.current = false;
      activeStickyMessageIdRef.current = null;
      return;
    }
    const anchoredHuman = [...(messageThreads || [])]
      .reverse()
      .find((message) => message?.sender === "human" && (!liveTextOutputting || message?.shouldAnchor));
    if (!anchoredHuman) {
      return;
    }

    const lastMessage = Array.isArray(messageThreads)
      ? messageThreads[messageThreads.length - 1]
      : null;
    // Keyed on the message identity only, NOT the thread uuid: a new thread's
    // temp uuid resolves to its real value mid-response, and including the uuid
    // here made the key change, re-anchoring the question to the top after the
    // answer arrived. The reset effect still clears these refs on a genuine
    // thread switch, so message identity alone is sufficient.
    const anchorMessageKey = String(
      anchoredHuman.id || anchoredHuman.uuid || anchoredHuman.createdAt || anchoredHuman.message || "",
    );

    if (activeAnchorMessageKeyRef.current !== anchorMessageKey) {
      activeAnchorMessageKeyRef.current = anchorMessageKey;
      followAnchorDuringLoadRef.current = true;
    }

    if (!followAnchorDuringLoadRef.current) {
      return;
    }

    const anchorKey = anchorMessageKey;
    if (lastAnchoredQuestionKeyRef.current === anchorKey) {
      return;
    }

    const delayMs = lastMessage?.sender === "human" ? INITIAL_HUMAN_ANCHOR_DELAY_MS : 0;

    let rafId = null;
    let timerId = null;
    // Mark the anchor as handled only when it actually runs — not when it is
    // scheduled. If this effect re-runs within `delayMs` (e.g. an extra
    // messageThreads update after an edit), the cleanup below cancels the
    // pending timer; recording the key here lets the re-run reschedule it
    // instead of bailing on "same-anchor-key".
    const runAnchor = () => {
      lastAnchoredQuestionKeyRef.current = anchorKey;
      rafId = requestAnimationFrame(scrollLastHumanToTop);
    };

    if (delayMs > 0) {
      timerId = setTimeout(runAnchor, delayMs);
    } else {
      runAnchor();
    }

    return () => {
      if (timerId) clearTimeout(timerId);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [
    activeThread?.threadUuid,
    liveTextOutputting,
    loadingResponse,
    userDetachedFromResponseAnchor,
    messageThreads,
    scrollLastHumanToTop,
  ]);

  const scrollToMessage = useCallback(() => {
    if (!scrollToMessageId) return;
    preserveAnchorPadAfterResponseRef.current = false;
    clearAnchorPad();
    if (!messageThreads?.length) return;
    const targetIdx = messageThreads.findIndex(
      (m) => String(m.id) === String(scrollToMessageId)
    );
    if (targetIdx === -1) return;
    initialScrollDoneRef.current = true;
    didInitialScroll.current = true;

    // Scroll to the target message
    const targetMessage = messageThreads[targetIdx];
    const msgId = domIdFor(targetMessage);
    const msgEl = messageRefs.current.get(msgId);
    if (msgEl) {
      msgEl.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    setShowScrollDown(true);
    lastAtBottomRef.current = false;
    setScrollToMessageId(null);
    setHideChatThread(false);
    revealChatLoadMetric("scroll-to-message");
  }, [
    clearAnchorPad,
    messageThreads,
    scrollToMessageId,
    setScrollToMessageId,
    setShowScrollDown,
    setHideChatThread,
    revealChatLoadMetric,
    domIdFor,
  ]);

  useLayoutEffect(() => {
    if (!scrollToMessageId) return;
    requestAnimationFrame(scrollToMessage);
  }, [scrollToMessageId, scrollToMessage]);


  const handleStartReached = useCallback(() => {
    if (!userData?.user_account_info) {
      return;
    }
    if (!hasMoreRef.current || !activeThreadUuid || !initialScrollDoneRef.current) {
      return;
    }
    const scroller = chatContainerRef.current;
    if (scroller && scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight <= 100) {
      return;
    }
    if (loadingOlderRef.current) {
      return;
    }
    if (startReachedCalledRef.current) {
      return;
    }

    startReachedCalledRef.current = true;
    setHistoryLoadIntentActive(true);

    if (historyLoadIntentTimerRef.current) clearTimeout(historyLoadIntentTimerRef.current);
    historyLoadIntentTimerRef.current = setTimeout(() => {
      historyLoadIntentTimerRef.current = null;
      setHistoryLoadIntentActive(false);
      startReachedCalledRef.current = false;
      loadOlderMessages({ threadUuid: activeThreadUuid });
    }, HISTORY_LOAD_DWELL_MS);
  }, [userData?.user_account_info, hasMore, activeThreadUuid, initialScrollDoneRef,
      chatContainerRef, loadingOlderRef, loadOlderMessages]);

  // critical to showing the data
  useEffect(() => {
    if (!loadingUserData) {
      // ensure no longer loading user state before rendering chat box
      setShowInitialMesageFlow(true);
      if (!isLoggedIn) {
        // if user is not logged in; can render immediately
        setDisplayChatBox(true);
      }
    }
  }, [loadingUserData, isLoggedIn]);

  useEffect(() => {
    if (loadingMessages) return;
    pushChatLoadMetric("loading-messages-complete", {
      messageCount: Array.isArray(messageThreads) ? messageThreads.length : 0,
    });
  }, [loadingMessages, messageThreads?.length, pushChatLoadMetric]);

  useEffect(() => {
    if (isSecondaryExperience != null) {
      if (isSecondaryExperience) {
        setShowButon1(0);
        setShowButon2(0);
        if (isDarkMode) {
          setTimeout(() => setShowButon1(0.99), 2666); //4000)
          setTimeout(() => setShowButon2(0.99), 3000); //4500)
          setTimeout(() => setShowMore(0.99), 2533); //3800)
          setTimeout(() => setShowOrb(0.99), 1933); //2900)
          setTimeout(() => setShowOrb(0), 7333); //11000)
        } else {
          setTimeout(() => setShowButon1(0.99), 2066); //3100)
          setTimeout(() => setShowButon2(0.99), 2400); //3600)
          setTimeout(() => setShowMore(0.99), 1933); //2900)
        }
      } else {
        setShowButon1(responseFlow?.question1?.[0] ? 0.99 : 0);
        setShowButon2(responseFlow?.question2?.[0] ? 0.99 : 0);
        setShowMore(responseFlow?.text ? 0.99 : 0);
      }
    }
  }, [
    isSecondaryExperience,
    responseFlow?.question1?.[0],
    responseFlow?.question2?.[0],
    responseFlow?.text,
  ]);


  useEffect(() => {
    if (needsHistory == true) {
      if (messageThreads && messageThreads.length > 1) {
        // must have rendered more than just starting message.
        setMessageThreadLoaded(true);
      }
    } else if (needsHistory == false) {
      setMessageThreadLoaded(true); // no messages to low, allow render
    }
  }, [messageThreads, needsHistory]);

  useEffect(() => {
    if (!messageThreadLoaded) return;
    pushChatLoadMetric("message-thread-loaded", {
      messageCount: Array.isArray(messageThreads) ? messageThreads.length : 0,
      loadingMessages: Boolean(loadingMessages),
    });
  }, [
    messageThreadLoaded,
    messageThreads?.length,
    loadingMessages,
    pushChatLoadMetric,
  ]);

  if (!isSecondaryExperience && (!messageThreads || !messageThreads.map || messageThreads.length === 0)) {
    return (
      <Box
        className="chatbox-div-container3"
        sx={{
          backgroundColor: themeColors.chatBoxColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
        }}
      >
        <Box
          component="img"
          src={isDarkMode ? NewLogoDarkMode : NewLogoLightMode}
          alt="Incite logo"
          sx={{ maxWidth: 170, width: "50%", opacity: 0.1, pointerEvents: "none", userSelect: "none" }}
        />
      </Box>
    );
  }

  return (
    <Box
      className="chatbox-div-container1"
      sx={{ backgroundColor: themeColors.chatBoxColor }}
    >
      {!isSecondaryExperience && hideChatThread && (
        <Box
          className="chatbox-div-container3"
          sx={{
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            zIndex: 2,
          }}
        >
          <Box
            component="img"
            src={isDarkMode ? NewLogoDarkMode : NewLogoLightMode}
            alt="Incite logo"
            sx={{
              maxWidth: 170,
              width: "50%",
              pointerEvents: "none",
              userSelect: "none",
              animation: `${orbPulsate} 2s ease-in-out infinite`,
              filter: isDarkMode
                ? "brightness(0) invert(1) drop-shadow(0 0 24px rgba(255,255,255,0.22))"
                : "brightness(1.18) contrast(1.08) drop-shadow(0 0 20px rgba(255,255,255,0.85))",
            }}
          />
        </Box>
      )}
      <Box
        className="chatbox-div-container3"
        sx={{
          backgroundColor: themeColors.chatBoxColor,

          ...(isDesktop && {
            left: `${chatLayout?.contentLeft ?? Math.max(sidebarOffset, 0)}px`,
            right: `${chatLayout?.contentRight ?? Math.max(-sidebarOffset, 0)}px`,
            width: "auto",
          }),
        }}
        ref={chatRef}
      >
        {showInitialMesageFlow && (
          <Box
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <Box
              className="chatbox-scroll-container"
              sx={{
                backgroundColor: themeColors.chatBoxColor, minHeight: 0,
                width: '100%',
                opacity: hideChatThread ? 0 : 1,
                transition: hideChatThread ? 'none' : 'opacity 0.35s ease-in',
                scrollAnchor: "auto",
              }}
              ref={chatContainerRef}
              onScroll={handleScrollDown}
              onWheel={markUserScrollIntent}
              onTouchMove={markUserScrollIntent}
              onMouseDown={markUserScrollIntent}
            >
              <Box
                className="inner-chatbox-scroll-container"
                sx={{
                  backgroundColor: themeColors.chatBoxColor,
                  width: '100%',
                }}
                ref={chatMessagesContainerRef}
              >
                <Box
                  sx={{
                    paddingBottom: "30px",
                    maxWidth: "100%",
                    minWidth: '100%',
                    margin: "auto",
                    position: "relative",
                  }}
                >
                  {!isSecondaryExperience && (historyLoadIntentActive || loadingOlder) && (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        pt: "14px",
                        pb: "2px",
                        minHeight: "36px",
                      }}
                    >
                      <CircularProgress
                        size={20}
                        thickness={4.5}
                        sx={{ color: isDarkMode ? "#AEB8C6" : "#576579" }}
                      />
                    </Box>
                  )}

                  { isSecondaryExperience && experienceMessageThreads[0] && messageThreads.length == 0 && 
                     <>
                      {secondaryExperienceType == "new-user" ? (
                        <PrintOutText
                          showDownArrowIcon={true}
                          message={
                            experienceMessageThreads[0].message
                          }
                          lineSpacing={[303, 250, 114]}
                        />
                      ) : (
                        <PrintOutText
                          showDownArrowIcon={true}
                          message={
                            experienceMessageThreads[0].message
                          }
                          lineSpacing={[329, 233, 100]}
                        />
                      )}
                    </>
                  }

                  {!isSecondaryExperience && (
                    <>
                      <div ref={topSentinelRef} style={{ height: 1 }} />
                      {visibleMessageThreads.map((mt, idx) => {
                        let marginVal;
                        if (
                          idx == 0 ||
                          visibleMessageThreads[idx].sender ==
                            visibleMessageThreads[idx - 1].sender
                        ) {
                          marginVal = "8px";
                        } else if (visibleMessageThreads[idx].isButton) {
                          marginVal = "17px";
                        } else {
                          marginVal = "17px";
                        }
                        let isLastMessage = idx == visibleMessageThreads.length - 1;
                        const { date_value, show_message_time } =
                          get_message_date(
                            visibleMessageThreads,
                            countSinceShowMessageTime,
                            idx
                          );
                        let styles = {};
                        if (idx == 0) {
                          styles = { marginTop: "12px", marginBottom: "16px" };
                        }

                        const msgId = domIdFor(mt);
                        return (
                          <Box
                            key={msgId}
                            ref={setMsgRef(msgId)}
                          >
                            {!(idx == 0 || isSecondaryExperience) &&
                              ((show_message_time && idx > 2) || idx == 0) && (
                                <Box
                                  className="chatbox-time"
                                  sx={{
                                    ...styles,
                                    color: isDarkMode ? "#606773" : "#9BABC2",
                                  }}
                                >
                                  {date_value}
                                </Box>
                              )}

                            {!isSecondaryExperience && (
                              <Box
                                ref={setMsgRef(msgId)}
                                sx={{
                                  marginTop: marginVal,
                                  display: "flex",
                                  flexDirection: "column",
                                  position: "relative",
                                }}
                              >
                                <ChatMessage
                                  msgId={msgId}
                                  idx={idx}
                                  messageThread={mt}
                                  priorMessageThread={(idx >= 1) ? visibleMessageThreads[idx - 1] : null}
                                  nextMessageThread={visibleMessageThreads[idx + 1] || null}
                                  loadingResponse={loadingResponse}
                                  isLastMessage={isLastMessage}
                                  isOrbAnchor={idx === orbAnchorIdx}
                                  showLoadingWaitingMessage={
                                    showLoadingWaitingMessage
                                  }
                                  setShowLoadingWaitingMessage={
                                    setShowLoadingWaitingMessage
                                  }
                                  useFullWidth={useFullWidth}
                                  setModalVisible={setModalVisible}
                                  setShowChatShare={setShowChatShare}
                                  questionOnDemand={questionOnDemand}
                                  setQuestionOnDemand={setQuestionOnDemand}
                                  preventQuestionInput={preventQuestionInput}
                                  setPreventQuestionInput={
                                    setPreventQuestionInput
                                  }
                                  onQuestionSubmit={onQuestionSubmit}
                                  secondaryExperienceType={
                                    secondaryExperienceType
                                  }
                                  isLoggedIn={isLoggedIn}
                                  freeUnlimitedOnly={freeUnlimitedOnly}
                                  hasShownFreeUnlimitedMessage={
                                    hasShownFreeUnlimitedMessage
                                  }
                                  onBeginEditMessage={onBeginEditMessage}
                                  onRemoveQueuedMessage={onRemoveQueuedMessage}
                                  onRetryQueuedMessage={onRetryQueuedMessage}
                                  suppressMessageActions={isDirectThread}
                                />
                              </Box>
                            )}
                          </Box>
                        );
                      })}
                    </>
                  )}
                    
                  {!isSecondaryExperience &&
                    !showChatShare &&
                    !loadingResponse && (
                      <Box
                        sx={{
                          marginTop: "24px",
                          marginBottom: "24px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></Box>
                    )}

                  {!isSecondaryExperience ? (
                    <Box sx={{}}></Box>
                  ) : (
                    <Box
                      sx={{ marginBottom: isDarkMode ? "72px" : "20px" }}
                    ></Box>
                  )}

                  {showChatShare && (
                    <>
                      <ShareModal
                        modalVisible={modalVisible}
                        setModalVisible={setModalVisible}
                      />
                      <ShareButtonChat
                        setShowChatShare={setShowChatShare}
                        transitionFlowButtonsAmount={
                          transitionFlowButtonsAmount
                        }
                        setModalVisible={setModalVisible}
                      />
                    </>
                  )}

                  {showSignInButtons ? (
                    <Box
                      sx={{
                        marginBottom: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <SignInApple
                        userData={userData}
                        setUserData={setUserData}
                        setErrors={setErrors}
                        onChatPage={true}
                      />
                      <SignInGoogle
                        userData={userData}
                        setUserData={setUserData}
                        setErrors={setErrors}
                        onChatPage={true}
                      />
                    </Box>
                  ) : (
                    <>
                      {shouldRenderQuestion1Button &&
                        !isDirectThread &&
                        !showChatShare &&
                        !editingMessage && (
                        <Box
                          sx={{
                            marginTop: "4px",
                            opacity: showButon1,
                            transition: "opacity 1s ease",
                          }}
                        >
                          <ChatButton
                            questionNumber={1}
                            //q={(isSecondaryExperience && !hasRefreshedButtons) ? newUserQuestion1 : responseFlow.question1[1]}
                            q={
                              isSecondaryExperience
                                ? newUserQuestion1
                                : responseFlow.question1[1]
                            }
                            action={responseFlow.question1[5]}
                            onRecommendedAction={onRecommendedAction}
                            onQuestionSubmit={onQuestionSubmit}
                            transitionFlowButtonsAmount={
                              transitionFlowButtonsAmount
                            }
                            preventQuestionInput={preventQuestionInput}
                            setPreventQuestionInput={setPreventQuestionInput}
                            //isSecondaryExperience={(isSecondaryExperience && !hasRefreshedButtons)}
                            isSecondaryExperience={isSecondaryExperience}
                            secondaryExperienceType={secondaryExperienceType}
                            userData={userData}
                            setUserData={setUserData}
                            setIsSecondaryExperience={setIsSecondaryExperience}
                            setModalVisible={setModalVisible}
                            setShowChatShare={setShowChatShare}
                            handleRegenerateSubmit={handleRegenerateSubmit}
                          />
                        </Box>
                      )}
                      {shouldRenderQuestion2Button &&
                        !isDirectThread &&
                        !showChatShare &&
                        !editingMessage && (
                        <Box
                          ref={chatMessageRef}
                          className={
                            isSecondaryExperience &&
                            secondaryExperienceType == "ask-share"
                              ? "bottom-button-placement"
                              : ""
                          }
                          sx={{
                            marginTop: "4px",
                            opacity: showButon2,
                            transition: "opacity 1s ease",
                          }}
                        >
                          <ChatButton
                            questionNumber={2}
                            // q={(isSecondaryExperience && !hasRefreshedButtons) ? newUserQuestion2 : responseFlow.question2[1]}
                            q={
                              isSecondaryExperience
                                ? newUserQuestion2
                                : responseFlow.question2[1]
                            }
                            action={responseFlow.question2[5]}
                            onRecommendedAction={onRecommendedAction}
                            onQuestionSubmit={onQuestionSubmit}
                            transitionFlowButtonsAmount={
                              transitionFlowButtonsAmount
                            }
                            preventQuestionInput={preventQuestionInput}
                            setPreventQuestionInput={setPreventQuestionInput}
                            // isSecondaryExperience={(isSecondaryExperience && !hasRefreshedButtons)}
                            isSecondaryExperience={isSecondaryExperience}
                            secondaryExperienceType={secondaryExperienceType}
                            userData={userData}
                            setUserData={setUserData}
                            setIsSecondaryExperience={setIsSecondaryExperience}
                            setModalVisible={setModalVisible}
                            setShowChatShare={setShowChatShare}
                            handleRegenerateSubmit={handleRegenerateSubmit}
                          />
                        </Box>
                      )}
                    </>
                  )}
                  <div
                    ref={padElRef}
                    data-anchor-pad
                    style={{ height: 0, width: 1, flex: '0 0 auto', pointerEvents: 'none' }}
                  />
                  <ScrollDown
                    isDesktop={isDesktop}
                    sidebarOffset={sidebarOffset}
                    showScrollDown={showScrollDown}
                    executeScroll={executeScroll}
                  /> 
                  <div ref={bottomSentinelRef} style={{ height: 1 }} />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>

      <Snackbar
        open={Boolean(historyInlineNotice)}
        autoHideDuration={4000}
        onClose={() => setHistoryInlineNotice("")}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setHistoryInlineNotice("")}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {historyInlineNotice}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ChatBox;
